/**
 * Created by mqamhieh on 8/1/18.
 */
(function () {

    "use strict";

    angular
        .module("harriApp")
        .service("userPermissions", UserPermissionsService);

    UserPermissionsService.$inject = ['$q', '$timeout'];

    function UserPermissionsService($q, $timeout) {
        var self = this;

        self.ACCESS_TYPES = {
            SOURCE_HIRE: "SOURCE_HIRE",
            TEAM: "TEAM_LIVE"
        };

        self.PERMISSION_CATEGORIES = {
            HARRI: 'HARRI',
            TEAM: 'TEAM',
            ENGAGE_360: 'ENGAGE_360',
        };

        self.PERMISSIONS = {
            MANAGE_BRAND_DETAILS : "MANAGE_BRAND_DETAILS",
            MANAGE_PRIVATE_JOB_POSTS : "MANAGE_PRIVATE_JOB_POSTS",
            MANAGE_MEDIA : "MANAGE_MEDIA",
            MANAGE_ANALYTICS_ACCESS: "MANAGE_ANALYTICS_ACCESS",
            MANAGE_ATR : "MANAGE_ATR",
            MANAGE_ROLES_GROUPS : "MANAGE_ROLES_GROUPS",
            MANAGE_USERS_IN_GROUPS : "MANAGE_USERS_IN_GROUPS",
            MANAGE_TEAMHUB_SETTINGS: "MANAGE_TEAMHUB_SETTINGS",
            ADD_AND_MANAGE_RECURRING_PAY_ADJUSTMENTS: "ADD_AND_MANAGE_RECURRING_PAY_ADJUSTMENTS",
            VIEW_FULL_LABOR_AND_WAGE_PERCENTAGES: "VIEW_FULL_LABOR_AND_WAGE_PERCENTAGES",
            ADD_USERS : "ADD_USERS",
            CREATE_EDIT_JOB_POST : "CREATE_EDIT_JOB_POST",
            VIEW_UNEMPLOYMENT_CLAIMS_REPORT : "VIEW_UNEMPLOYMENT_CLAIMS_REPORT",
            CREATE_JOB_POST_FROM_TEMPLATE_AND_PARTIALLY_EDIT : "CREATE_JOB_POST_FROM_TEMPLATE_AND_PARTIALLY_EDIT",
            CREATE_JOB_POST_FROM_TEMPLATE : "CREATE_JOB_POST_FROM_TEMPLATE",
            PUBLISH_JOB_POST : "PUBLISH_JOB_POST",
            DISTRIBUTE_BOOST_JOB_POST : "DISTRIBUTE_BOOST_JOB_POST",
            DELETE_ARCHIVE_JOB_POST : "DELETE_ARCHIVE_JOB_POST",
            RUN_CHECK_IN_FOR_EMPLOYEES : "RUN_CHECK_IN_FOR_EMPLOYEES",
            VIEW_MANAGER_SCHEDULE_REPORT : "VIEW_MANAGER_SCHEDULE_REPORT",
            VIEW_CHECK_IN_RECORDS : "VIEW_CHECK_IN_RECORDS",
            FILL_JOB_POST : "FILL_JOB_POST",
            MANAGE_REPORTS_SETTINGS : "MANAGE_REPORTS_SETTINGS",
            MANAGE_DOCS_OFFERS_WITH_EDIT_DESCRIPTION : "MANAGE_DOCS_OFFERS_WITH_EDIT_DESCRIPTION",
            MANAGE_DOCS_OFFERS : "MANAGE_DOCS_OFFERS",
            MANAGE_DOCS_OFFERS_FROM_TEMPLATE : "MANAGE_DOCS_OFFERS_FROM_TEMPLATE",
            ACCESS_EMPLOYEE_EDITS_REPORT: 'ACCESS_EMPLOYEE_EDITS_REPORT',
            SEND_TO_PAYROLL : "SEND_TO_PAYROLL",
            SEND_RECOGNITION_AND_POINTS: "SEND_RECOGNITION_AND_POINTS",
            MANAGE_NOTIFICATIONS: "MANAGE_NOTIFICATIONS",
            I_9_REVIEW_AND_E_VERIFY : "I_9_REVIEW_AND_E_VERIFY",
            MANAGE_QUESTIONS_AND_TEMPLATES_BANK: 'MANAGE_QUESTIONS_AND_TEMPLATES_BANK',
            MANAGE_REVIEW_CYCLES: 'MANAGE_REVIEW_CYCLES',
            MANAGE_OVERALL_RATING_RULES: 'MANAGE_OVERALL_RATING_RULES',
            MANAGE_PMS_GENERAL_SETTINGS: 'MANAGE_PMS_GENERAL_SETTINGS',
            VIEW_PERFORMANCE_REVIEW_RECORDS: 'VIEW_PERFORMANCE_REVIEW_RECORDS',
            MANAGE_CHECK_IN_REVIEWS: 'MANAGE_CHECK_IN_REVIEWS',
            MANAGE_SALARIED_EMPLOYEES_TIME_CARDS: "MANAGE_SALARIED_EMPLOYEES_TIME_CARDS",
            MANAGE_WEIGHTED_SHIFT_EMPLOYEES_TIME_CARDS: "MANAGE_WEIGHTED_SHIFT_EMPLOYEES_TIME_CARDS",
            MANAGE_HOURLY_EMPLOYEES_TIME_CARDS: "MANAGE_HOURLY_EMPLOYEES_TIME_CARDS",
            SEND_REGULAR_SCHEDULE_WITH_VIOLATION: "SEND_REGULAR_SCHEDULE_WITH_VIOLATION",
            ADVANCED_PDS_ACCESS: "ADVANCED_PDS_ACCESS",
            VIEW_PERFORMANCE_REVIEW_DASHBOARD: "VIEW_PERFORMANCE_REVIEW_DASHBOARD",
            CAN_REOPEN_PDS: "CAN_REOPEN_PDS",
            APPROVE_TEAMLIVE_LOCATION_PERIOD: "APPROVE_TEAMLIVE_LOCATION_PERIOD",
            APPROVE_TEAMLIVE_POSITION: "APPROVE_TEAMLIVE_POSITION",
            MANAGE_HOURLY_EMPLOYEES_WAGES: "MANAGE_HOURLY_EMPLOYEES_WAGES",
            VIEW_HOURLY_EMPLOYEES_WAGES: "VIEW_HOURLY_EMPLOYEES_WAGES",
            MANAGE_SALARIED_EMPLOYEES_WAGES: "MANAGE_SALARIED_EMPLOYEES_WAGES",
            VIEW_SALARIED_EMPLOYEES_WAGES: "VIEW_SALARIED_EMPLOYEES_WAGES",
            MANAGE_EQUAL_OPPORTUNITIES_INFORMATION: "MANAGE_EQUAL_OPPORTUNITIES_INFORMATION",
            MANAGE_WEIGHTED_SHIFT_EMPLOYEES_WAGES: "MANAGE_WEIGHTED_SHIFT_EMPLOYEES_WAGES",
            VIEW_WEIGHTED_SHIFT_EMPLOYEES_WAGES: "VIEW_WEIGHTED_SHIFT_EMPLOYEES_WAGES",
            ACCESS_RISK_DETECTION_DASHBOARD : "ACCESS_RISK_DETECTION_DASHBOARD",
            MANAGE_BRAND_PERMISSIONS: "MANAGE_BRAND_PERMISSIONS",
            MANAGE_DATA_CLEANSING_SETTINGS: "MANAGE_DATA_CLEANSING_SETTINGS",
            MANAGE_TEAM_LIVE_BUSINESS_SETTINGS: "MANAGE_TEAM_LIVE_BUSINESS_SETTINGS",
            MANAGE_ABSENCES: "MANAGE_ABSENCES",
            MY_JOBS_REASSIGN_JOB_POSTS: "MY_JOBS_REASSIGN_JOB_POSTS",
            MANAGE_TEAM_LIVE_ADMINS: 'MANAGE_TEAM_LIVE_ADMINS',
            MANAGE_MINOR_WORK_PERMIT_EXEMPT_PERIODS: 'MANAGE_MINOR_WORK_PERMIT_EXEMPT_PERIODS',
            CAN_SKIP_KEESING_VERIFICATION: 'CAN_SKIP_KEESING_VERIFICATION',
            MANAGE_BANK_ACCOUNT_DETAILS: 'MANAGE_BANK_ACCOUNT_DETAILS',
            CAN_SKIP_TRUST_ID_VERIFICATION: 'CAN_SKIP_TRUST_ID_VERIFICATION',
            CAN_BYPASS_TRUST_ID_VERIFICATION: 'CAN_BYPASS_TRUST_ID_VERIFICATION',
            OVERRIDE_WOTC_RESTRICTIONS:'OVERRIDE_WOTC_RESTRICTIONS',
            EDIT_PAY_RULES_SETTINGS: 'EDIT_PAY_RULES_SETTINGS',
            MANAGE_FORECASTING_SETTINGS: 'MANAGE_FORECASTING_SETTINGS',
            MANAGE_FORECASTING_TEMPLATE: 'MANAGE_FORECASTING_TEMPLATE',
            MANAGE_STATIONS_WITH_NO_SKILL_LEVEL: 'MANAGE_STATIONS_WITH_NO_SKILL_LEVEL',
            MANAGE_GFE_NOTIFICATIONS_SETTINGS: 'MANAGE_GFE_NOTIFICATIONS_SETTINGS',
            MANAGE_TALENT_POOL_CRM: 'MANAGE_TALENT_POOL_CRM',
            MANAGE_MINOR_RULES_SETTINGS: 'MANAGE_MINOR_RULES_SETTINGS',
            MANAGE_BREAKS_SETTINGS: 'MANAGE_BREAKS_SETTINGS',
            VIEW_BREAKS_SETTINGS: 'VIEW_BREAKS_SETTINGS',
            RESEND_I9_WITH_OPEN_EVERIFY_CASE: 'RESEND_I9_WITH_OPEN_EVERIFY_CASE',
            CREATE_NEW_EMPLOYEES: 'CREATE_NEW_EMPLOYEES',
            MANAGE_NOTIFICATION_EMAIL: 'MANAGE_NOTIFICATION_EMAIL',
            EDIT_EMPLOYEE_CONTACT_DETAILS: 'EDIT_EMPLOYEE_CONTACT_DETAILS',
            VIEW_EMPLOYEE_CONTACT_DETAILS: 'VIEW_EMPLOYEE_CONTACT_DETAILS',
            VIEW_UN_SCHEDULED_EMPLOYEE_REPORT: 'VIEW_UN_SCHEDULED_EMPLOYEE_REPORT',
            EDIT_PERSONAL_INFO: 'EDIT_PERSONAL_INFO',
            EDIT_EMPLOYMENT_INFO: 'EDIT_EMPLOYMENT_INFO',
            EDIT_PAYROLL_DETAILS: 'EDIT_PAYROLL_DETAILS',
            MANAGE_WITHHOLDING_DETAILS: 'MANAGE_WITHHOLDING_DETAILS',
            IMPORT_NEW_EMPLOYEES: 'IMPORT_NEW_EMPLOYEES',
            ADD_WALK_INS: 'ADD_WALK_INS',
            MANAGE_POS_POSITIONS: 'MANAGE_POS_POSITIONS',
            SEND_TO_POS: 'SEND_TO_POS',
            MANAGE_BRAND_POSITIONS: 'MANAGE_BRAND_POSITIONS',
            MANAGE_EMPLOYEE_REFERRAL: 'MANAGE_EMPLOYEE_REFERRAL',
            RUN_REVIEWS_FOR_EMPLOYEES: 'RUN_REVIEWS_FOR_EMPLOYEES',
            APPROVE_EMPLOYEES_REVIEWS: 'APPROVE_EMPLOYEES_REVIEWS',
            MANAGE_BILLING_DETAILS: 'MANAGE_BILLING_DETAILS',
            MANAGE_EMPLOYEE_REFERRAL_TEMPLATES: 'MANAGE_EMPLOYEE_REFERRAL_TEMPLATES',
            MANAGE_QUESTION_BANK_VIDEO_INTERVIEW_FIELDS: 'MANAGE_QUESTION_BANK_VIDEO_INTERVIEW_FIELDS',
            MANAGE_VIDEO_INTERVIEW_QUESTION_TYPES: 'MANAGE_VIDEO_INTERVIEW_QUESTION_TYPES',
            MANAGE_VIDEO_INTERVIEW_MEDIA: 'MANAGE_VIDEO_INTERVIEW_MEDIA',
            MANAGE_VIDEO_INTERVIEW_TEMPLATES: 'MANAGE_VIDEO_INTERVIEW_TEMPLATES',
            MANAGE_SCHEDULE: 'MANAGE_SCHEDULE',
            BYPASS_SCHEDULE_PUBLISH_RESTRICTIONS: 'BYPASS_SCHEDULE_PUBLISH_RESTRICTIONS',
            MANAGE_FORECAST_GENERATION: 'MANAGE_FORECAST_GENERATION',
            MANAGE_FORECAST_AND_SCHEDULE_GENERATION: 'MANAGE_FORECAST_AND_SCHEDULE_GENERATION',
            PUBLISH_SCHEDULE: 'PUBLISH_SCHEDULE',
            APPROVE_SCHEDULE: 'APPROVE_SCHEDULE',
            MANAGE_BUDGET: 'MANAGE_BUDGET',
            MANAGE_BUDGET_SETTINGS: 'MANAGE_BUDGET_SETTINGS',
            MANAGE_VIEW_SATISFACTION: 'MANAGE_VIEW_SATISFACTION',
            APPROVE_ALL_TIME_CARDS: 'APPROVE_ALL_TIME_CARDS',
            REQUEST_BACKGROUND_CHECKS: 'REQUEST_BACKGROUND_CHECKS',
            VIEW_BACKGROUND_CHECKS_RESULTS: 'VIEW_BACKGROUND_CHECKS_RESULTS',
            MANAGE_OWN_PROFILE: 'MANAGE_OWN_PROFILE',
            BYPASS_BACKGROUND_CHECK: 'BYPASS_BACKGROUND_CHECK',
            MANAGE_WOTC_ELIGIBILITY: 'MANAGE_WOTC_ELIGIBILITY',
            MANAGE_BACKGROUND_CHECK_SETTINGS: 'MANAGE_BACKGROUND_CHECK_SETTINGS',
            MANAGE_AMS_COLUMNS: 'MANAGE_AMS_COLUMNS',
            ACCESS_FLASH_WAGE_TYPE_SUMMARY_REPORT: 'ACCESS_FLASH_WAGE_TYPE_SUMMARY_REPORT',
            MANAGE_GLOBAL_TAGS: 'MANAGE_GLOBAL_TAGS',
            ACCESS_CLOSED_LOCATIONS: 'ACCESS_CLOSED_LOCATIONS',
            VIEW_CANDIDATE_NOTES: 'VIEW_CANDIDATE_NOTES',
            MANAGE_CANDIDATE_NOTES: 'MANAGE_CANDIDATE_NOTES',
            MANAGE_PRIVATE_TAGS: 'MANAGE_PRIVATE_TAGS',
            MANAGE_TALENT_POOL_MODULE: 'MANAGE_TALENT_POOL_MODULE',
            MANAGE_MINORS_SCHOOL_INFORMATION: 'MANAGE_MINORS_SCHOOL_INFORMATION',
            MANAGE_SHIFT_TRADE_REQUESTS: 'MANAGE_SHIFT_TRADE_REQUESTS',
            MANAGE_FWW_PENALTIES_SETTING: 'MANAGE_FWW_PENALTIES_SETTING',
            VIEW_EMPLOYEES_PUNCH_PHOTOS: 'VIEW_EMPLOYEES_PUNCH_PHOTOS',
            VIEW_JOB_POSTINGS: 'VIEW_JOB_POSTINGS',
            MANAGE_JOB_CANDIDATES: 'MANAGE_JOB_CANDIDATES',
            MANAGE_EMAIL_CONTENT: 'MANAGE_EMAIL_CONTENT',
            HIRE_CANDIDATES_WITH_OPEN_E_VERIFY_CASES: 'HIRE_CANDIDATES_WITH_OPEN_E_VERIFY_CASES',
            RETRIEVE_CANDIDATES_FROM_SKIP_COLUMN: 'RETRIEVE_CANDIDATES_FROM_SKIP_COLUMN',
            VIEW_SKIP_COLUMN: 'VIEW_SKIP_COLUMN',
            ONBAORDING_MANAGE_CUSTOM_DOCUMENTS: 'ONBAORDING_MANAGE_CUSTOM_DOCUMENTS',
            MANAGE_LOGBOOK_SETTINGS: 'MANAGE_LOGBOOK_SETTINGS',
            MANAGE_APPROVAL_FLOWS_SETTINGS: 'MANAGE_APPROVAL_FLOWS_SETTINGS',
            OVERRIDE_APPROVALS: 'OVERRIDE_APPROVALS',
            ACCESS_ADVANCED_ONBOARDING_OVERVIEW: 'ACCESS_ADVANCED_ONBOARDING_OVERVIEW',
            ACCESS_ADVANCED_ONBOARDING_MANAGERS_VIEW: 'ACCESS_ADVANCED_ONBOARDING_MANAGERS_VIEW',
            MANAGE_PUBLISH_RESTRICTION_SETTINGS: 'MANAGE_PUBLISH_RESTRICTION_SETTINGS',
            MANAGE_PAYSHEET_PAYRUN: 'MANAGE_PAYSHEET_PAYRUN',
            MANAGE_EMPLOYEE_QUESTIONNAIRE: 'MANAGE_EMPLOYEE_QUESTIONNAIRE',
            VIEW_NO_PAY_REPORT: 'VIEW_NO_PAY_REPORT',
            VIEW_EMPLOYEE_QUESTIONNAIRE_REPORT: 'VIEW_EMPLOYEE_QUESTIONNAIRE_REPORT',
            MANAGE_EMPLOYEE_QUESTIONNAIRE_NOTIFICATION: 'MANAGE_EMPLOYEE_QUESTIONNAIRE_NOTIFICATION',
            ACCESS_COMPASS_DASHBOARD: 'ACCESS_COMPASS_DASHBOARD',
            MANAGE_AVERAGE_CHECK_AMOUNT_ADJUSTMENT: 'MANAGE_AVERAGE_CHECK_AMOUNT_ADJUSTMENT',
            ASSIGN_TASKS: 'ASSIGN_TASKS',
            EDIT_AND_DELETE_ALL_TASKS: "EDIT_AND_DELETE_ALL_TASKS",
            CREATE_EDIT_AND_DELETE_YOUR_OWN_CHECK_LISTS: "CREATE_EDIT_AND_DELETE_YOUR_OWN_CHECK_LISTS",
            EDIT_AND_DELETE_ALL_CHECK_LISTS: "EDIT_AND_DELETE_ALL_CHECK_LISTS",
            VIEW_ENTRIES: 'VIEW_ENTRIES',
            MANAGE_ENTRIES: 'MANAGE_ENTRIES',
            MANAGE_OFFER_TEMPLATES: 'MANAGE_OFFER_TEMPLATES',
            MANAGE_DOC_DEFAULT_FIELDS: 'MANAGE_DOC_DEFAULT_FIELDS',
            MANAGE_GFE_INCIDENTS: 'MANAGE_GFE_INCIDENTS',
            MANAGE_VSL: 'MANAGE_VSL',
            MANAGE_AUTOMATED_METRIC: 'MANAGE_AUTOMATED_METRIC',
            MANAGE_WAGE_MATRIX: 'MANAGE_WAGE_MATRIX',
            OVERRIDE_WAGE_MATRIX: 'OVERRIDE_WAGE_MATRIX',
            MANAGE_BLOCKED_PAST_EMPLOYEES: 'MANAGE_BLOCKED_PAST_EMPLOYEES',
            RESOLVE_RTR_PENALTY_AS_EXCEPTION: 'RESOLVE_RTR_PENALTY_AS_EXCEPTION',
            TERMINATE_REHIRE: 'TERMINATE_REHIRE',
            TERMINATE_WITHIN_30_DAYS: 'TERMINATE_WITHIN_30_DAYS',
            CAN_MANAGE_HOME_LOCATION: 'CAN_MANAGE_HOME_LOCATION',
            CAN_MANAGE_SHARED_LOCATION: 'CAN_MANAGE_SHARED_LOCATION',
            CORE_HR_SEND_TO_PAYROLL: 'CORE_HR_SEND_TO_PAYROLL',
            MANAGE_OWN_REQUESTS: 'MANAGE_OWN_REQUESTS',
            MANAGE_EMPLOYEES_REQUESTS: 'MANAGE_EMPLOYEES_REQUESTS',
            MANAGE_SICKNESS_REQUESTS: 'MANAGE_SICKNESS_REQUESTS',
            MANAGE_AVAILABILITY_REQUESTS: 'MANAGE_AVAILABILITY_REQUESTS',
            MANAGE_TIMEOFF_REQUESTS: 'MANAGE_TIMEOFF_REQUESTS',
            MANAGE_ABSENCE_REQUESTS: 'MANAGE_ABSENCE_REQUESTS',
            MANAGE_EMPLOYEE_HOLIDAY_PLANS: 'MANAGE_EMPLOYEE_HOLIDAY_PLANS',
            VIEW_ONBOARDING_DOCUMENTS: 'VIEW_ONBOARDING_DOCUMENTS',
            UPLOAD_DOCUMENTS: 'UPLOAD_DOCUMENTS',
            MOVE_CANDIDATES_TO_ONBOARDING_SWIMLANES: 'MOVE_CANDIDATES_TO_ONBOARDING_SWIMLANES',
            SEND_TRUST_ID_CASE: 'SEND_TRUST_ID_CASE',
            MANAGE_EMPLOYEE_NOTES: 'MANAGE_EMPLOYEE_NOTES',
            VIEW_HR_ACTIONS: 'VIEW_HR_ACTIONS',
            MANAGE_HR_ACTIONS_APPROVALS: 'MANAGE_HR_ACTIONS_APPROVALS',
            MANAGE_MINOR_MINIMUM_AGE: 'MANAGE_MINOR_MINIMUM_AGE',
            MANAGE_HR_ACTIONS_TEMPLATES: 'MANAGE_HR_ACTIONS_TEMPLATES',
            ISSUE_AN_HR_ACTION: 'ISSUE_AN_HR_ACTION',
            VIEW_SETTINGS_AUDIT_TRAIL: 'VIEW_SETTINGS_AUDIT_TRAIL',
            CAN_MANAGE_USER_PUNCHES: 'MANAGE_PUNCHES',
            CAN_MANAGE_OWN_PUNCHES: 'MANAGE_OWN_PUNCHES',
            MANAGE_OWN_TIME_CARDS: 'MANAGE_OWN_TIME_CARDS',
            CREATE_UPDATE_LEAVE_OF_ABSENCE: 'CREATE_UPDATE_LEAVE_OF_ABSENCE',
            MANAGE_LEAVE_OF_ABSENCE_RTW_DATE: 'MANAGE_LEAVE_OF_ABSENCE_RTW_DATE',
            DELETE_UPCOMING_LEAVE_OF_ABSENCE: 'DELETE_UPCOMING_LEAVE_OF_ABSENCE',
            BLOCK_USERS: 'BLOCK_USERS',
            MANAGE_COMMSHUB_SETTINGS: 'MANAGE_COMMSHUB_SETTINGS',
            MANAGE_GENERAL_SETTINGS: 'MANAGE_GENERAL_SETTINGS',
            MANAGE_EQUAL_EMPLOYMENT_OPPORTUNITY_QUESTIONS: 'MANAGE_EQUAL_EMPLOYMENT_OPPORTUNITY_QUESTIONS',
            MANAGE_SHIFTS_SETTINGS: 'MANAGE_SHIFTS_SETTINGS',
            MANAGE_MEDIA_SETTINGS: 'MANAGE_MEDIA_SETTINGS',
            MANAGE_SCHOOL_CALENDAR_TEMPLATES_SETTINGS: 'MANAGE_SCHOOL_CALENDAR_TEMPLATES_SETTINGS',
            MANAGE_TEAMLIVE_NOTIFICATIONS_SETTINGS: 'MANAGE_TEAMLIVE_NOTIFICATIONS_SETTINGS',
            VIEW_ATTENDANCE_RELIABILITY_REPORT: 'VIEW_ATTENDANCE_RELIABILITY_REPORT',
            VIEW_AVAILABILITY_REPORT: 'VIEW_AVAILABILITY_REPORT',
            VIEW_EMPLOYEE_ROSTER_REPORT: 'VIEW_EMPLOYEE_ROSTER_REPORT',
            VIEW_MCHIRE_INTEGRATION_REJECTION_REPORT: 'VIEW_MCHIRE_INTEGRATION_REJECTION_REPORT',
            VIEW_FRED_INTEGRATION_REJECTION_REPORT: 'VIEW_FRED_INTEGRATION_REJECTION_REPORT',
            VIEW_DAILY_CREW_SCHEDULE_LINE_BAR_REPORT: 'VIEW_DAILY_CREW_SCHEDULE_LINE_BAR_REPORT',
            VIEW_SCHEDULE_CHANGE_REPORT: 'VIEW_SCHEDULE_CHANGE_REPORT',
            VIEW_WEEKLY_SCHEDULE_REPORT: 'VIEW_WEEKLY_SCHEDULE_REPORT',
            VIEW_DAILY_ACTIVITY_REPORT: 'VIEW_DAILY_ACTIVITY_REPORT',
            VIEW_CLOCK_OUT_ATTESTATION_ANSWERS: 'VIEW_CLOCK_OUT_ATTESTATION_ANSWERS',
            VIEW_FORECAST_ACCURACY_REPORT: 'VIEW_FORECAST_ACCURACY_REPORT',
            VIEW_LABOR_ANALYSIS_REPORT: 'VIEW_LABOR_ANALYSIS_REPORT',
            VIEW_LABOR_EXCEPTION_REPORT: 'VIEW_LABOR_EXCEPTION_REPORT',
            MANAGE_DATE_OF_BIRTH: 'MANAGE_DATE_OF_BIRTH',
            VIEW_PAY_PERIOD_REPORT: 'VIEW_PAY_PERIOD_REPORT',
            ACCESS_EMPLOYEE_TURNOVER_REPORT: 'ACCESS_EMPLOYEE_TURNOVER_REPORT',
            VIEW_TIME_PUNCH_REPORTS: 'VIEW_TIME_PUNCH_REPORTS',
            VIEW_FULL_PUNCH_REPORTS: 'VIEW_FULL_PUNCH_REPORTS',
            VIEW_PUNCH_CHANGE_APPROVAL_REPORT: 'VIEW_PUNCH_CHANGE_APPROVAL_REPORT',
            SCHEDULE_REPORTS: 'SCHEDULE_REPORTS',
            MANAGE_ALL_SCHEDULED_REPORTS: 'MANAGE_ALL_SCHEDULED_REPORTS',
            CAN_LOCK_TIMESHEET: 'CAN_LOCK_TIMESHEET',
            CAN_UNLOCK_TIMESHEET: 'CAN_UNLOCK_TIMESHEET',
            DELETE_MESSAGES: 'DELETE_MESSAGES',
            VIEW_DELETED_MESSAGES_OF_MY_GROUPS: 'VIEW_DELETED_MESSAGES_OF_MY_GROUPS',
            VIEW_ALL_DELETED_MESSAGES: 'VIEW_ALL_DELETED_MESSAGES',
            VIEW_LIVE_WIRE_AND_HARRI_LIVE_DASHBOARDS: 'VIEW_LIVE_WIRE_AND_HARRI_LIVE_DASHBOARDS',
            VIEW_BIOMETRIC_CONSENT_REPORT: 'VIEW_BIOMETRIC_CONSENT_REPORT',
            ACCESS_BREAK_WAIVER_CONSENT_REPORT: 'ACCESS_BREAK_WAIVER_CONSENT_REPORT',
            MANAGE_CUSTOM_CANDIDATES_SOURCE: 'MANAGE_CUSTOM_CANDIDATES_SOURCE',
            MANAGE_TOUCHPOINTS: 'MANAGE_TOUCHPOINTS',
            VIEW_EMPLOYEE_ENGAGEMENT: 'VIEW_EMPLOYEE_ENGAGEMENT',
            VIEW_TEAM_ENGAGEMENT: 'VIEW_TEAM_ENGAGEMENT',
            MANAGE_CLOCK_OUT_ATTESTATION_QUESTIONS: 'MANAGE_CLOCK_OUT_ATTESTATION_QUESTIONS',
            MANAGE_ON_BOARDING_JOURNEY_EVENTS: 'MANAGE_ON_BOARDING_JOURNEY_EVENTS',
            MANAGE_ADAM: 'MANAGE_ADAM',
            MANAGE_MEAL_BREAK_WAIVER_TEMPLATES: 'MANAGE_MEAL_BREAK_WAIVER_TEMPLATES',
            VIEW_SCHEDULE_CREATION_METRICS_REPORT : 'VIEW_SCHEDULE_CREATION_METRICS_REPORT',
            MANAGE_WORK_RESTRICTION_VISA_DETAILS: 'MANAGE_WORK_RESTRICTION_VISA_DETAILS',
            MANAGE_WORK_RESTRICTION_VISA_TYPE: 'MANAGE_WORK_RESTRICTION_VISA_TYPE',
            MANAGE_WORK_RESTRICTION_RULES: 'MANAGE_WORK_RESTRICTION_RULES',
            MANAGE_WORK_RESTRICTION_CALENDARS: 'MANAGE_WORK_RESTRICTION_CALENDARS',
            RESOLVE_CALIFORNIA_BREAK_PREMIUMS: 'RESOLVE_CALIFORNIA_BREAK_PREMIUMS',
            VIEW_HALO_DASHBOARD: 'VIEW_HALO_DASHBOARD',
            ACCESS_PAYROLL_REPORT: 'ACCESS_PAYROLL_REPORT',
            MANAGE_REWARDS_CONFIGURATION: 'MANAGE_REWARDS_CONFIGURATION',
            MANAGE_REWARDS_BUDGETS: 'MANAGE_REWARDS_BUDGETS',
            MANAGE_REWARDS_RULES: 'MANAGE_REWARDS_RULES',
            MANAGE_REWARDS_RAFFLES: 'MANAGE_REWARDS_RAFFLES',
            MANAGE_CAREER_STORY_PAGE: 'MANAGE_CAREER_STORY_PAGE',
            MANAGE_POSITION_HIERARCHY_SETTINGS: 'MANAGE_POSITION_HIERARCHY_SETTINGS',
            CAN_EXCEED_AVAILABLE_TO_DATE_BALANCE: 'CAN_EXCEED_AVAILABLE_TO_DATE_BALANCE',
            APPROVE_EMPLOYEES_REVIEWS_SECOND_STEP: 'APPROVE_EMPLOYEES_REVIEWS_SECOND_STEP',
            VIEW_ADP_EMPLOYEE_SYNC_STATUS_REPORT: 'VIEW_ADP_EMPLOYEE_SYNC_STATUS_REPORT',
            VIEW_WORK_VISA_DETAILS_IN_REPORTS: 'VIEW_WORK_VISA_DETAILS_IN_REPORTS',
        };

        self.MANAGE_WAGES = [
            self.PERMISSIONS.MANAGE_HOURLY_EMPLOYEES_WAGES,
            self.PERMISSIONS.MANAGE_SALARIED_EMPLOYEES_WAGES,
            self.PERMISSIONS.MANAGE_WEIGHTED_SHIFT_EMPLOYEES_WAGES
        ];

        self.VIEW_WAGES = [
            self.PERMISSIONS.VIEW_HOURLY_EMPLOYEES_WAGES,
            self.PERMISSIONS.VIEW_SALARIED_EMPLOYEES_WAGES,
            self.PERMISSIONS.VIEW_WEIGHTED_SHIFT_EMPLOYEES_WAGES
        ];

        self.ONBOARDING = [
            self.PERMISSIONS.MANAGE_DOCS_OFFERS_FROM_TEMPLATE,
            self.PERMISSIONS.MANAGE_DOCS_OFFERS
        ];

        self.VIEW_ONBOARDING = [
            self.PERMISSIONS.MANAGE_DOCS_OFFERS_FROM_TEMPLATE,
            self.PERMISSIONS.MANAGE_DOCS_OFFERS,
            self.PERMISSIONS.VIEW_ONBOARDING_DOCUMENTS
        ];

        self.MANAGE_TIME_CARDS = [
            self.PERMISSIONS.MANAGE_HOURLY_EMPLOYEES_TIME_CARDS,
            self.PERMISSIONS.MANAGE_WEIGHTED_SHIFT_EMPLOYEES_TIME_CARDS,
            self.PERMISSIONS.MANAGE_SALARIED_EMPLOYEES_TIME_CARDS
        ];

        self.CREATE_JOB_PERMISSIONS = [
            self.PERMISSIONS.CREATE_EDIT_JOB_POST,
            self.PERMISSIONS.CREATE_JOB_POST_FROM_TEMPLATE_AND_PARTIALLY_EDIT,
            self.PERMISSIONS.CREATE_JOB_POST_FROM_TEMPLATE
        ];

        self.CONDITION_TYPE =  {
            JOB_BOARD : "JOB_BOARD",
            POSITION_CATEGORY : "POSITION_CATEGORY",
            LOGBOOK_ENTRY_TYPE: 'LOGBOOK_ENTRY_TYPE',
            EMPLOYMENT_TYPE: 'EMPLOYMENT_TYPE',
            PERMISSION: 'PERMISSION',
        };

        self.LMS = {
            MANAGE_LEARNERS: "MANAGE_LEARNERS",
            MANAGE_UN_ENROLLMENTS: "MANAGE_UN_ENROLLMENTS",
            MANAGE_AUTO_ENROLLMENT_SETTINGS: "MANAGE_AUTO_ENROLLMENT_SETTINGS",
            ASSIGN_COURSE: "ASSIGN_COURSE",
            MANAGE_ADMIN_TRAINING: "MANAGE_ADMIN_TRAINING"
        };

        self.getBrandPolicy = function (brandIds) {
            var defer = $q.defer();

            brandIds = angular.isArray(brandIds)? brandIds: [brandIds];

            const cleanBrandIds = brandIds.filter(id => !!id);

            if (cleanBrandIds.length !== brandIds.length) {
                console.error("Trying to load brand policy with invalid brandId:", brandIds);

                if (cleanBrandIds.length === 0) {
                    defer.reject('Failed to load user permissions');
                    return defer.promise;
                }
            }

            loadBrandsPolicy(cleanBrandIds)
                .then(function (policy) {
                    var parser = new PolicyParser(brandIds);
                    parser.updatePolicy(policy);
                    defer.resolve(parser)
                }, function (error) {
                    console.log(error);
                });

            return defer.promise;
        };

        var cachedUserAccess = [];
        var cachedBrandsPolicies = {};
        var nextLoaderTimeout;
        var brandIdsForNextRequest = [];
        var brandIdsBeingLoaded = [];
        var waitingList = [];

        self.getPermissionLogbookEntryValues = function (brandId, permission) {
            var defer = $q.defer();

            self.getBrandPolicy(brandId)
                .then(function (policyParser) {
                    var hasPermission = policyParser.has(permission);

                    if (hasPermission) {
                        var types = [];
                        var permissionIndex = _.findIndex(cachedBrandsPolicies[brandId].permissions, function (item) {
                            return item.name === permission;
                        });
                        var permissionConditions = cachedBrandsPolicies[brandId].permissions[permissionIndex].conditions;
                        for (var i in permissionConditions) {
                            if (permissionConditions[i].type == "LOGBOOK_ENTRY_TYPE" && permissionConditions[i].values) {
                                types = permissionConditions[i].values;
                                break;
                            }
                        }
                        defer.resolve(types);
                    }
                    else {
                        defer.resolve(null);
                    }

                }, function (error) {
                    console.log(error);
                    defer.reject();
                });

            return defer.promise;
        };

        self.getPermissionCategoryValues = function (brandId, permission) {
            var defer = $q.defer();

            self.getBrandPolicy(brandId)
                .then(function (policyParser) {
                    var hasPermission = policyParser.has(permission);

                    if (hasPermission) {
                        var categories = [];
                        var permissionIndex = _.findIndex(cachedBrandsPolicies[brandId].permissions, function (item) {
                            return item.name === permission;
                        });
                        var permissionConditions = cachedBrandsPolicies[brandId].permissions[permissionIndex].conditions;
                        for (var i in permissionConditions) {
                            if (permissionConditions[i].type == "POSITION_CATEGORY" && permissionConditions[i].values) {
                                categories = permissionConditions[i].values;
                                break;
                            }
                        }
                        defer.resolve(categories);
                    }
                    else {
                        defer.resolve(null);
                    }

                }, function (error) {
                    console.log(error);
                    defer.reject();
                });

            return defer.promise;
        };

        var loadBrandsPolicy = function (brandsIds) {
            var defer = $q.defer();
            var notCachedBrandIds = [];

            for (var i in brandsIds) {
                if (!cachedBrandsPolicies[brandsIds[i]]) {
                    notCachedBrandIds.push(brandsIds[i]);
                }
            }

            if (notCachedBrandIds.length === 0) {
                // Nothing to load, everything is cached and ready
                defer.resolve(preparePolicy(brandsIds));
            }
            else {
                // Cancel execution of previously initialized loader timeout, and re-run again
                $timeout.cancel(nextLoaderTimeout);
                var notAlreadyRequestedBrandIds = _.difference(notCachedBrandIds, brandIdsBeingLoaded);
                brandIdsForNextRequest = _.unique(brandIdsForNextRequest.concat(notAlreadyRequestedBrandIds));

                waitingList.push({
                    brandIds: brandsIds,
                    defer: defer
                });

                nextLoaderTimeout = $timeout(function () {
                    if (brandIdsForNextRequest.length > 0) {
                        brandIdsBeingLoaded = _.unique(brandIdsBeingLoaded.concat(brandIdsForNextRequest));
                        var promises = [];
                        for (var i = 0; i < brandIdsForNextRequest.length;) {
                            var start = i;
                            var end = (i + 50) >= brandIdsForNextRequest.length ? brandIdsForNextRequest.length : i + 50;
                            var subArray = angular.copy(brandIdsForNextRequest).slice(start, end);
                            promises.push(PermissionsAPI.getUserBrandPolicy(subArray));
                            i = i + 50;
                        }

                        $q.all(promises)
                            .then(function (res) {
                                var policy = {brands: [], user_accesses: []};
                                for (var i = 0; i < promises.length; i++) {
                                    policy['brands'] = policy['brands'].concat(res[i]['brands']);
                                    policy['user_accesses'] = policy['user_accesses'].concat(res[i]['user_accesses']);
                                }

                                cachedUserAccess = policy.user_accesses;
                                for (var i in policy.brands) {
                                    cachedBrandsPolicies[policy.brands[i].brandId] = policy.brands[i];

                                    if (brandIdsBeingLoaded.indexOf(policy.brands[i].brandId) > -1) {
                                        brandIdsBeingLoaded.splice(brandIdsBeingLoaded.indexOf(policy.brands[i].brandId), 1);
                                    }
                                    else {
                                        console.warn("Expected to find brandId:", policy.brands[i].brandId, "in brandIdsBeingLoaded:", brandIdsBeingLoaded);
                                    }
                                }
                                checkWaitingList();
                            })
                            .catch(function (err) {
                                console.error(err);
                            });
                        brandIdsForNextRequest = [];
                    }
                }, 10);

            }

            return defer.promise;
        };

        var checkWaitingList = function () {
            for (var i = waitingList.length - 1; i >= 0; i--) {
                var cachedPolicy = preparePolicy(waitingList[i].brandIds);
                if (cachedPolicy) {
                    waitingList[i].defer.resolve(cachedPolicy);
                    waitingList.splice(i, 1);
                }
            }
        };

        var preparePolicy = function (brandsIds) {
            var policy = { brands: [], user_accesses: cachedUserAccess };
            brandsIds = _.unique(brandsIds);

            for (var i in brandsIds) {
                if (!cachedBrandsPolicies[brandsIds[i]]) {
                    // If any of the requested brands is missing, return null to indicate unavailability
                    return null;
                }
                policy.brands.push(cachedBrandsPolicies[brandsIds[i]]);
            }

            return policy;
        };

        const [hasPermissionOnBrandOrAnyChild] = cacheService.cache(ReportingManagementAPI.hasPermissionOnBrandOrAnyChild);

        self.hasPermissionOnBrandOrAnyChild = async (brandId, permissionCode, permissionCategory, oneOfPermissions) => {
            try {
                const isAuthorizedPermission = await hasPermissionOnBrandOrAnyChild(brandId, permissionCode, permissionCategory, oneOfPermissions);
                return isAuthorizedPermission.authorized;
            }
            catch (error) {
                console.error("Error checking hasPermissionOnBrandOrAnyChild:", error);
                return false;
            }
        };
    }

    var PolicyParser = function (brandIds, rejected) {
        var self = this;

        self.ALL = "ALL";
        self.ANY = "ANY";
        self.rejected = rejected || false;
        var _policy;

        self.updatePolicy = function (policy) {
            _policy = JSON.parse(JSON.stringify(policy));
        };

        /**
         * Create new copy from current policyParser-object state, to prevent mutating the original
         * policyParser instance.
         * We need to use clone method in the following cases:
         * @example
         * policyParser.brand(policyParser.ANY).has(userPermissions.PERMISSIONS.MANAGE_ATR);
         * policyParser.has(userPermissions.PERMISSIONS.MANAGE_MEDIA);
         * the second check will give us a wrong result, if the permission (MANAGE_MEDIA) only added on one brand,
         * and other brands don't have the permission, to fix this we have to use clone() method:
         * policyParser.clone().brand(policyParser.ANY).has(userPermissions.PERMISSIONS.MANAGE_ATR);
         * policyParser.clone().has(userPermissions.PERMISSIONS.MANAGE_MEDIA);
         */
        self.clone = function () {
            var parser = new PolicyParser(brandIds, self.rejected);
            parser.updatePolicy(_policy);
            return parser;
        };

        self.brand = function (brandIdModifier) {

            // Filter will endup with two results, if this step will reject the whole flow, and the policy after applying filtration
            // Init reject with previously inherited reject value
            var reject = self.rejected;
            var filteredPolicy = _policy;

            // If it is already rejected, no need to check any of the rules
            if (!self.rejected) {
                switch (brandIdModifier) {
                    // Check ANY brand modifier
                    case self.ANY:
                        // Only if user has access to none of the loaded brands, consider as rejected
                        if (_policy.brands.length === 0) {
                            reject = true;
                        }
                        filteredPolicy = _policy;
                        filteredPolicy.brandModifier = self.ANY;
                        break;

                    case self.ALL:
                        // All initially requested brandIds should be checked for existence or it will be rejected
                        var policyBrandIds = _.pluck(_policy.brands, "brandId");
                        var allFound = true;

                        for (var i in brandIds) {
                            if (policyBrandIds.indexOf(brandIds[i]) === -1) {
                                allFound = false;
                            }
                        }

                        // We need to or with reject, so make sure that we don't lose reject flag from previous checks
                        reject = reject || !allFound;
                        // Keep the same policy, it will have all brands, or rejected due to previous check
                        filteredPolicy = _policy;
                        break;
                    default:
                        filteredPolicy = { 'brands': [], 'user_accesses': _policy.user_accesses};
                        var bIds = angular.isArray(brandIdModifier)? brandIdModifier: [brandIdModifier];

                        for (var i in _policy.brands) {
                            var brandPolicy = _policy.brands[i];
                            var indexInRequestedBrandsIds = bIds.indexOf(brandPolicy.brandId);

                            if (indexInRequestedBrandsIds > -1) {
                                filteredPolicy.brands.push(brandPolicy);
                                // Remove it from requested Ids, so we can check what is remaining
                                bIds.splice(indexInRequestedBrandsIds, 1);
                            }
                        }

                        if (bIds.length > 0) {
                            // Some of the requested brand ids was not found, setting reject to true
                            reject = true;
                        }
                        break;
                }
            }


            var parser = new PolicyParser(brandIds, reject);
            parser.updatePolicy(filteredPolicy);
            return parser;
        };
        // Alias
        self.brands = self.brand;

        var condition = function (type, modifier, subModifier) {
            // Init reject with previously inherited reject value
            var reject = self.rejected;
            // Filter policy based on condition type and modifier, if already rejected, it doesn't matter
            var filteredPolicy = _policy;

            // If it is already rejected, no need to check any of the rules
            if (!self.rejected) {
                filteredPolicy = {
                    'brands': [],
                    'user_accesses': _policy.user_accesses,
                    'brandModifier': _policy.brandModifier
                };

                for (var i in _policy.brands) {
                    var brandPolicy = _policy.brands[i];
                    var filteredBrandPolicy = {brandId: brandPolicy.brandId, permissions: []};
                    brandPolicy.permissions = brandPolicy.permissions || [];

                    for (var j in brandPolicy.permissions) {
                        var allowed = evaluatePermissionCondition(brandPolicy.permissions[j], type, modifier, subModifier);
                        if (allowed) {
                            filteredBrandPolicy.permissions.push(brandPolicy.permissions[j]);
                        }
                    }

                    filteredPolicy.brands.push(filteredBrandPolicy);
                }
            }

            var parser = new PolicyParser(brandIds, reject);
            parser.updatePolicy(filteredPolicy);
            return parser;
        };

        self.position = function (categoryFilter, positionyFilter) {
            if ([self.ANY, self.ALL].indexOf(categoryFilter) > -1) {
                throw "Category Filter is not valid";
            }

            return condition("POSITION_CATEGORY", categoryFilter, positionyFilter);
        };

        self.positions = self.position;

        self.category = function (categoryFilter) {
            return condition("POSITION_CATEGORY", categoryFilter);
        };
        // alias
        self.categories = self.category;

        self.board = function (boardFilter) {
            return condition("JOB_BOARD", boardFilter);
        };

        self.permission = function (permissionFilter) {
            return condition('PERMISSION', permissionFilter);
        };

        self.permissions = self.permission;

        self.employmentType = (employmentTypeFilter) => {
            return condition(`EMPLOYMENT_TYPE`, employmentTypeFilter);
        };

        self.employmentTypes = self.employmentType;

        // alias
        self.boards = self.board;

        self.hasAny = function (permissions) {
            if (!permissions || !angular.isArray(permissions)) {
                throw "permissions should be an array, given: " + JSON.stringify(permissions);
            }

            for (var i in permissions) {
                if (self.has(permissions[i])) {
                    return true;
                }
            }

            return false;
        };

        self.hasAll = function (permissions) {
            if (!permissions || !angular.isArray(permissions)) {
                throw "permissions should be an array, given: " + JSON.stringify(permissions);
            }

            for (var i in permissions) {
                if (!self.has(permissions[i])) {
                    return false;
                }
            }

            return true;
        };

        self.has = function (permission) {
            if (typeof permission !== 'string') {
                throw "permissions should be a string, given: " + JSON.stringify(permission);
            }

            if (rejected) {
                return false;
            }

            var foundOnce = false;
            var foundInAll = true;

            for (var i in _policy.brands) {
                var brandPermissions = _policy.brands[i].permissions;
                var index = _.findIndex(brandPermissions, function (item) {
                    return item.name === permission;
                });

                if (index > -1) {
                    foundOnce = true;
                }
                else {
                    foundInAll = false
                }
            }

            if (_policy.brandModifier === self.ANY && foundOnce) {
                return true;
            }

            return foundInAll;
        };

        self.hasAccess = function (system) {
            return _policy.user_accesses.indexOf(system) > -1;
        };

        var evaluatePermissionCondition = function (permission, conditionType, conditionValue, subConditionValue) {
            var conditionValueToCheck = subConditionValue || conditionValue;

            permission.conditions = permission.conditions || [];
            var condition = _.find(permission.conditions, function (item) {
                return item.type === conditionType;
            }) || {};

            condition.values = condition.values || [];

            if (condition.values.length === 0) {
                // Permission has no conditions with this type, this means that ALL is allowed
                return true;
            }

            if (subConditionValue) {
                condition = _.find(condition.values, function (item) {
                    return item.code === conditionValue;
                }) || {};
                if (!condition.values ) {
                    return false;
                } else if (condition.values.length === 0) {
                    return true;
                }
            }

            condition.values = condition.values || [];

            switch (conditionValueToCheck) {
                case self.ANY:
                    // If permission already exists, this means that you've all or any
                    return true;
                case self.ALL:
                    // Returning false, we've previously checked if conditions.values.length === 0 Sorry :(
                    return false;
                default:
                    var values = angular.isArray(conditionValueToCheck) ? conditionValueToCheck : [conditionValueToCheck];
                    var allFound = true;

                    var conditionValuesWithoutSubConditions = []

                    for (var i in condition.values) {
                        if (condition.values[i].code && (!condition.values[i].values || condition.values[i].values.length === 0)) {
                            conditionValuesWithoutSubConditions.push(condition.values[i].code);
                        }
                    }

                    for (var i in values) {
                        if (conditionValuesWithoutSubConditions.indexOf(values[i]) === -1) {
                            allFound = false;
                            break;
                        }
                    }

                    return allFound;
            }
        }
    };
})();
